var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 51,
    viewBox: "0 0 49 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2988,
    cy: 23.2988,
    r: 23.2988,
    transform: "matrix(1 0 0 -1 2 48.5977)",
    fill: "url(#paint0_linear_8828_67826)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2988 48.5975C12.4312 48.5975 2 38.1663 2 25.2988C2 12.4312 12.4312 2 25.2988 2",
    stroke: "#FFD84D",
    strokeWidth: 3.06563,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1689 30.9281C26.1689 30.3781 25.7189 29.9281 25.1689 29.9281H16.1689V23.9281H34.1689V17.9281C34.1689 16.8281 33.2689 15.9281 32.1689 15.9281H16.1689C15.0589 15.9281 14.1789 16.8181 14.1789 17.9281L14.1689 29.9281C14.1689 31.0381 15.0589 31.9281 16.1689 31.9281H25.1689C25.7189 31.9281 26.1689 31.4781 26.1689 30.9281ZM32.1689 19.9281H16.1689V17.9281H32.1689V19.9281ZM32.1689 33.9281C31.6189 33.9281 31.1689 33.4781 31.1689 32.9281V30.9281H29.1689C28.6189 30.9281 28.1689 30.4781 28.1689 29.9281C28.1689 29.3781 28.6189 28.9281 29.1689 28.9281H31.1689V26.9281C31.1689 26.3781 31.6189 25.9281 32.1689 25.9281C32.7189 25.9281 33.1689 26.3781 33.1689 26.9281V28.9281H35.1689C35.7189 28.9281 36.1689 29.3781 36.1689 29.9281C36.1689 30.4781 35.7189 30.9281 35.1689 30.9281H33.1689V32.9281C33.1689 33.4781 32.7189 33.9281 32.1689 33.9281Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8828_67826",
    x1: 76.4598,
    y1: 5.70225,
    x2: 0.259572,
    y2: 46.3767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD84D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B468",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40499D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/PaymentIcon.159d82074097b5d3232e2ae54053325c.svg";
export { ForwardRef as ReactComponent };